import React from "react";
import SnLabel from "./SnLabel";
import SnTextBox from "./SnTextBox";

type Props = {
  nmLabel?: string;
  label?: string;
  text?: string;
  cd_param?: string;
  cdParam?: string;
  fields?: string[];
  values?: any[];
  labelWidth?: string;
  data?: any;
  rowData?: any;
  value?: any;
  defaultValue?: any;
};

const getFields = (props: Props) =>
  props.fields ??
  String(props.cd_param ?? props.cdParam ?? "")
    .split(",")
    .map((field) => field.trim())
    .filter(Boolean);

const getSource = (props: Props) =>
  props.data ?? props.rowData ?? props.value ?? props.defaultValue ?? {};

const SnLinkedInfoBox = (props: Props) => {
  const fields = getFields(props);
  const source = getSource(props);
  const values = props.values ?? fields.map((field) => source?.[field] ?? "");
  const label = props.nmLabel ?? props.label ?? props.text ?? "";

  return (
    <div
      className="grid items-center gap-x-2"
      style={{ gridTemplateColumns: `${props.labelWidth ?? "90px"} repeat(${values.length}, minmax(0, 1fr))` }}
    >
      <SnLabel text={label} type="FreeForm" />
      {values.map((value, index) => (
        <div key={index} className="min-w-0">
          <SnTextBox defaultValue={value ?? ""} isReadOnly={true} />
        </div>
      ))}
    </div>
  );
};

export default SnLinkedInfoBox;
